module.exports = __webpack_public_path__ + "static/media/check.8992b21a.svg";